"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));

var _PageTitle = _interopRequireDefault(require("../../molecules/PageTitle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PageSpinner(props) {
  return _react.default.createElement("div", {
    className: "py-32 flex justify-center items-center",
    "data-testid": "page-spinner"
  }, _react.default.createElement(_PageTitle.default, null), _react.default.createElement(_LoadingSpinner.default, null));
}

var _default = _react.default.memo(PageSpinner);

exports.default = _default;